import React from 'react';
import { noteIcon } from '@chordbaker/design';

interface NoteIconProps {
  size?: number;
  color?: string;
  className?: string;
}

const paths = noteIcon.elements as { d: string }[];

const NoteIcon: React.FC<NoteIconProps> = ({
  size = noteIcon.defaultSize,
  color = 'currentColor',
  className = '',
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox={noteIcon.viewBox}
      fill={noteIcon.fill}
      stroke={color}
      strokeWidth={noteIcon.strokeWidth}
      strokeLinecap={noteIcon.strokeLinecap as React.SVGAttributes<SVGSVGElement>['strokeLinecap']}
      strokeLinejoin={noteIcon.strokeLinejoin as React.SVGAttributes<SVGSVGElement>['strokeLinejoin']}
      className={className}
      aria-hidden="true"
    >
      {paths.map(path => (
        <path key={path.d} d={path.d} />
      ))}
    </svg>
  );
};

export default NoteIcon;
